@if (searchMessage.message) {
  <div class="pb-3">
    <p class="text-sm leading-relaxed" [innerHTML]="searchMessage.message | linkify"></p>
    @if (searchMessage.totalCount) {
      <p class="text-sm"><b>{{'searchResult.totalCount'| translate}}:</b> {{searchMessage.totalCount}}</p>
    }
  </div>
}

@if (searchMessage.searchResultItems && searchMessage.searchResultItems.length>0) {
  <div class="flex flex-col md:flex-row md:items-center justify-between gap-3 pb-5">
    <div class="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
      @if (documentNo) {
        <div>
          <b>{{ 'searchResult.headers.documentNumber' | translate }}:</b> {{documentNo}}
        </div>
      }
      @if (orderer) {
        <div>
          <b>{{ 'searchResult.headers.orderer' | translate }}:</b> {{orderer}}
        </div>
      }
      @if (date) {
        <div>
          <b>{{ 'searchResult.headers.date' | translate }}:</b> {{date | date: 'dd.MM.yyyy'}}
        </div>
      }
    </div>
    <div class="flex items-center gap-2 shrink-0">
      @if (!readOnly && isPdfArchive) {
        <button type="button" pButton [icon]="isPdfDownloading() ? 'pi pi-spin pi-spinner' : 'pi pi-file-pdf'" size="small"
          [label]="'searchResult.openPdf' | translate" (click)="openPdf()" [disabled]="isPdfDownloading()"></button>
      }
      <button type="button" pButton icon="pi pi-external-link" size="small" [label]="'searchResult.openDocument'| translate"
      (click)="openDocument()"></button>
    </div>
  </div>
  <div class="table-container text-sm">
    <p-table [resizableColumns]="true" columnResizeMode="expand"  [value]="searchMessage.searchResultItems">
      <ng-template #header>
        <tr>
          <th pResizableColumn>{{ 'searchResult.headers.position' | translate }}</th>
          <th pResizableColumn>{{ 'searchResult.headers.articleNo' | translate }}</th>
          <th pResizableColumn>{{ 'searchResult.headers.description' | translate }}</th>
          <th pResizableColumn class="text-end">{{ 'searchResult.headers.quantity' | translate }}</th>
          <th pResizableColumn class="currency-align">{{ 'searchResult.headers.unitPrice' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-searchItem>
        <tr>
          <td>
            <span class="p-column-title">{{ "searchResult.headers.position" | translate }}</span>
            <span>{{ searchItem.position}}</span>
          </td>
          <td>
            <span class="p-column-title">{{ "searchResult.headers.articleNo" | translate }}</span>
            <span class="truncate hover:text-clip w-full table-col-primary" [title]="searchItem.articleNo">{{ searchItem.articleNo }}</span></td>
            <td>
              <span class="p-column-title">{{ "searchResult.headers.description" | translate }}</span>
              <span class="truncate hover:text-clip w-full" [title]="searchItem.articleDescription">{{ searchItem.articleDescription }}</span>
            </td>
            <td class="text-end">
              <span class="p-column-title">{{ "searchResult.headers.quantity" | translate }}</span>
              <span>{{ searchItem.quantity}}</span>
            </td>
            <td class="currency-align">
              <span class="p-column-title">{{ "searchResult.headers.unitPrice" | translate }}</span>
              <span>{{ searchItem.unitPrice | currency:(searchItem.documentCurrency ? searchItem.documentCurrency : 'EUR'):'symbol':'1.2-2':locale() }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
